export default "__VITE_ASSET__udAFmfEb__"